import { FaTag } from 'react-icons/fa';
import { IoMdCube } from 'react-icons/io';
import {
  MdKingBed,
  MdFlight,
  MdDirectionsCar,
  MdDirectionsBus,
  MdDirectionsBoat,
  MdOutlineTour,
  MdCabin,
} from 'react-icons/md';
import { RiArrowLeftRightFill } from 'react-icons/ri';
import {
  COMPONENT_ACCOMMODATION,
  COMPONENT_EXTRA,
  COMPONENT_FLIGHT,
  COMPONENT_TOUR,
  COMPONENT_CAR_HIRE,
  COMPONENT_TRANSFER,
  COMPONENT_COACH,
  COMPONENT_CRUISE,
  COMPONENT_CABIN,
  COMPONENT_PACKAGE,
} from 'shared/constants/common';

export default function QuoteBookingComponentIcon({ componentType, fillColor }) {
  switch (componentType) {
    case COMPONENT_ACCOMMODATION:
      return <MdKingBed style={{ fill: fillColor }}/>;
    case COMPONENT_EXTRA:
      return <FaTag style={{ fill: fillColor }}/>;
    case COMPONENT_FLIGHT:
      return <MdFlight style={{ fill: fillColor }}/>;
    case COMPONENT_TOUR:
      return <MdOutlineTour style={{ fill: fillColor }} />;
    case COMPONENT_CAR_HIRE:
      return <MdDirectionsCar style={{ fill: fillColor }}/>;
    case COMPONENT_TRANSFER:
      return <RiArrowLeftRightFill style={{ fill: fillColor }}/>;
    case COMPONENT_COACH:
      return <MdDirectionsBus style={{ fill: fillColor }}/>;
    case COMPONENT_CRUISE:
      return <MdDirectionsBoat style={{ fill: fillColor }}/>;
    case COMPONENT_CABIN:
      return <MdCabin style={{ fill: fillColor }}/>;
    case COMPONENT_PACKAGE:
      return <IoMdCube style={{ fill: fillColor }}/>;
    default:
      return null;
  }
}
